
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import userx from '../../store/modules/userx';
import { AccountMinimumData } from '../../store/models.def';
import mwx from '../../store/modules/mediumwarex';

@Component({
	components: {},
})
export default class AddMyAccount extends Vue {
	@Prop({ default: [] }) public readonly allAccounts!: AccountMinimumData[];
	@Prop({ default: null }) public readonly value!: AccountMinimumData | null;

	public selected: AccountMinimumData | null = null;

	public get selectedName() {
		return this.selected ? this.selected.companyName : 'Please Select';
	}

	public select(account: AccountMinimumData) {
		this.selected = account;
		this.$emit('input', account);
	}
	@Watch('value')
	public onValueChange(
		newVal: AccountMinimumData | null,
		oldVal: AccountMinimumData | null,
	) {
		this.selected = newVal;
	}

	public async addAccount() {
		if (this.selected) {
			await userx.addMyAccount(this.selected);
		}
	}
}
